import React, { useContext, Fragment } from 'react'
import { useQuery } from '@apollo/client'
import { ProductFiltersContext } from '../../../context/ProductFiltersContext'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { getCities } from '../../../queries'

export default function Cities (): JSX.Element {
  const { filters, setFilters } = useContext(ProductFiltersContext)
  const { loading, error, data } = useQuery(getCities(filters.orderStates))

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations.cities) return <p>No data found</p>

  const cities: Array<string> = []
  data.ordersAggs.aggregations.cities.buckets.map((city: any) => {
    cities.push(city.key)
  })

  const onChange = (value: any) => {
    setFilters({
      orderCities: value
    })
  }
  const typographLabel = 'Município'

  return (
    <Fragment>
      <AutocompleteComponent
        labelValue={typographLabel}
        data={cities}
        defaultValues={filters.orderCities}
        onChange={onChange}
      />
    </Fragment>
  )
}
